class PrintCurrencyPickReportController {
  constructor($timeout) {
    'ngInject';
    this.$timeout = $timeout;
    this.date = '';
    this.routeId = '';
    this.fundingSource = '';
    this.denominations = [];
  }

  $onInit() {
    if (window.opener && window.opener.w && window.opener.w.printData) {
      const data = window.opener.w.printData;
      this.date = data.date;
      this.routeId = data.routeId;
      this.fundingSource = data.fundingSource;
      this.denominations = data.denominations || [];
      this.grandTotals = data.grandTotals;
    }
    this.$timeout(() => {
      window.print();
    }, 1000);
  }
  formatAmount(amount) {
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: amount < 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }
}

export default PrintCurrencyPickReportController;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/currency_pick_report/print_currency_pick_report/print_currency_pick_report.controller.js